export { Fade } from './fade';
